import {
    Box,
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from '@mui/material';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import pxToRem from 'assets/theme/function/px-to-rem';
import { initialListData } from 'pages/product/products/index';
import { ProductAddRequest } from 'types/product/product';
import { useStatusListQuery } from 'store/slices/user/user';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
    setDataProductRequestList?: React.Dispatch<
        React.SetStateAction<ProductAddRequest>
    >;
    productCategoryList: string[] | undefined;
}
const FilterProduct: React.FC<Props> = (props: Props) => {
    const { setDataProductRequestList, productCategoryList } = props;
    const { handleSubmit, control, reset } = useForm<ProductAddRequest>();

    const { data: statusList } = useStatusListQuery();

    const onSubmit = (values: ProductAddRequest) => {
        if (setDataProductRequestList) {
            setDataProductRequestList((prevState) => ({
                ...prevState,
                title: values.title,
                productNumber: values.productNumber,
                productCategory: values.productCategory,
                status: values.status,
            }));
        }
    };

    const resets = () => {
        reset();
        if (setDataProductRequestList) {
            setDataProductRequestList(initialListData);
        }
    };
    return (
        <Box
            pt={pxToRem(10)}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            component="form"
            onSubmit={handleSubmit(onSubmit)}
        >
            <Box display={'flex'} flexBasis={'100%'}>
                <Controller
                    name="title"
                    control={control}
                    render={({
                        field: { name, value = '', onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Product Title'}
                            name={name}
                            value={value || ''}
                            sx={{ width: '30%' }}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                        />
                    )}
                />

                <Controller
                    name="productNumber"
                    control={control}
                    render={({
                        field: { name, value = '', onChange },
                        fieldState: { error },
                    }) => (
                        <TextField
                            label={'Position Number'}
                            name={name}
                            value={value || ''}
                            onChange={onChange}
                            error={Boolean(error)}
                            helperText={error?.message || ''}
                            sx={{ ml: pxToRem(10), width: '30%' }}
                        />
                    )}
                />

                <FormControl sx={{ ml: pxToRem(10), width: '30%' }}>
                    <InputLabel>Card Category</InputLabel>
                    <Controller
                        name="productCategory"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                label="Product Category"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Product Category"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onChange('')}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {productCategoryList?.map((status) => (
                                    <MenuItem
                                        key={status.toString()}
                                        value={status.toString()}
                                    >
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>

                <FormControl sx={{ ml: pxToRem(10), width: '30%' }}>
                    <InputLabel>Product Status</InputLabel>
                    <Controller
                        name="status"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                label="Product Status"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Product Status"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => onChange('')}
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {statusList?.map((status) => (
                                    <MenuItem
                                        key={status.toString()}
                                        value={status.toString()}
                                    >
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>
            </Box>

            <Box display={'flex'} alignItems={'center'} ml={pxToRem(20)}>
                <Button
                    fullWidth
                    sx={{ mr: pxToRem(20), px: pxToRem(20) }}
                    variant={'contained'}
                    type={'submit'}
                >
                    Search
                </Button>
                <Button
                    fullWidth
                    sx={{ px: pxToRem(20) }}
                    variant={'contained'}
                    color={'secondary'}
                    onClick={resets}
                >
                    Clear
                </Button>
            </Box>
        </Box>
    );
};

export default FilterProduct;
